import { atom, selector } from 'recoil';
import Roles from '../components/role/roles';
import { verificarToken, getTokenData } from './storage';

export interface Usuario {
  id: string;
  nombre: string;
  unidad: string;
  rol: any;
}

const usuarioEffect =
  () =>
  ({ trigger, onSet, setSelf }) => {
    const token = localStorage.getItem('tokenEcosurEstudiantesExternos');
    if (trigger === 'get' && token && verificarToken(token)) {
      const tokenData = getTokenData(token);
      setSelf({
        id: tokenData.id,
        rol: Roles[tokenData.role],
      } as Usuario);
    }
    onSet((newValue: Usuario) => {
      if (token && verificarToken(token)) {
        setSelf(newValue);
      } else {
        setSelf({} as Usuario);
      }
    });
  };

export const usuarioState = atom({
  key: 'usuarioState',
  default: {} as Usuario,
  effects: [usuarioEffect()],
});

export const usuarioInfo = selector({
  key: 'usuarioInfo',
  get: ({ get }) => ({
    usuario: get(usuarioState),
    id: get(usuarioState).id,
    nombre: get(usuarioState).nombre,
    unidad: get(usuarioState).unidad,
    rol: get(usuarioState).rol,
  }),
});
